<template>
    <div class="up-for-date mt-4 mx-5 fs-14px">
        <div class="d-flex">
            <div :class="{
                    'fw-600 fs-14px': true,
                    'w-30': $detect == 'web'
                }">Tài khoản có:</div>
            <div :class="{
                'w-70': $detect == 'web',
                'ml-3': $detect == 'mobile'
            }">
                <span class="mb-0"><span class="text-danger fw-600">{{money.money_text}}</span> {{money.unit}}</span>
                <span class="ml-3"><a href="https://vatgia.com/nap-tien.html" class="btn-recharge">Nạp {{money.unit}}</a></span>
            </div>
        </div>
        <div :class="{
                'mt-4': true,
                'd-flex': $detect == 'web'
            }">
            <div :class="{
                    'fw-600 fs-14px': true,
                    'w-30': $detect == 'web'
                }">Số lần up {{product.length > 1 ? 'mỗi tin' : ''}}:</div>
            <div :class="{
                    'w-70': $detect == 'web',
                    'mt-2': $detect == 'mobile'
                }">
                <input type="text" inputmode="numeric" class="input-number-up" v-model="count"
                    @input="calculateTotal" @focus="(e) => e.target.select()"/>
                {{config.con_product_auto_up_price ? config.con_product_auto_up_price.unit : ''}}
                <span class="mx-1" v-if="product.length > 1">x {{product.length}} tin</span>
                <span class="mx-1">=</span>
                <input type="text" inputmode="numeric" class="input-price-up ml-1" v-model="total"
                    @input="calculateCount" @focus="(e) => e.target.select()"/> {{money.unit}}
                <p class="mb-0 text-secondary fs-12px mt-2">* Tối đa 10.000 lần hoặc {{$formatNumber(product.length * 10000 * (config.con_product_auto_up_price ? config.con_product_auto_up_price.money : 0))}} {{money.unit}}</p>
            </div>
        </div>
        <div :class="{
                'mt-4': true,
                'd-flex': $detect == 'web'
            }">
            <div :class="{
                    'fw-600 fs-14px': true,
                    'w-30': $detect == 'web'
                }">Ngày up:</div>
            <div :class="{
                'w-70': $detect == 'web'
            }">
                <div :class="{
                        'custom-control custom-checkbox':true,
                        'mt-2': $detect == 'mobile'
                    }">
                    <input type="checkbox" class="custom-control-input" id="allday" v-model="allDay"
                        @change="changeAllDay()">
                    <label class="custom-control-label" for="allday">Tất cả các thứ trong tuần</label>
                </div>
                <div class="select-up-detail">
                    <ldc-select-show-option
                        :showPlaceholder="false"
                        :multiple="true"
                        v-model="valueDays">
                        <ldc-option-show
                            v-for="(item, index) in day" :key="index"
                            :value="item.value"
                            :label="item.label"/>
                    </ldc-select-show-option>
                </div>
            </div>
        </div>
        <div class="custom-control custom-checkbox" v-show="valueDays.length > 0" v-if="$detect == 'mobile'">
            <input type="checkbox" class="custom-control-input" id="detailDay" v-model="inputTime">
            <label class="custom-control-label fs-14px" for="detailDay">Đặt thời gian chi tiết cho từng ngày</label>
        </div>
        <div :class="{
                'mt-4': true,
                'd-flex': $detect == 'web'
            }">
            <div :class="{
                'fw-600': true,
                'w-30': $detect == 'web'
            }">Thời gian up:</div>
            <div :class="{
                    'w-70': $detect == 'web'
                }">
                <div class="time-up-detail">
                    <div class="custom-control custom-checkbox" v-show="valueDays.length > 0" v-if="$detect == 'web'">
                        <input type="checkbox" class="custom-control-input" id="customCheck1" v-model="inputTime">
                        <label class="custom-control-label fs-14px" for="customCheck1">Đặt thời gian chi tiết cho từng ngày</label>
                    </div>
                    <div v-show="!inputTime">
                        <div class="d-flex flex-wrap flex-time">
                            <div class="col-time-auto mt-2" v-for="(item, index) in timeAutos" :key="index">
                                <div class="d-flex">
                                    <div class="col-time mr-2 position-relative">
                                        <ldc-time placeholder="HH:mm"
                                            :showSeconds="false"
                                            :jumpMinutes="5"
                                            v-model="timeAutos[index]"
                                            titleMobile="Thời gian"/>
                                        <div class="btn-delete-time position-absolute"
                                            v-if="timeAutos.length > 1"
                                            role="button" @click="removeTime(index)">
                                            <i class="icon ion-md-close text-danger fs-16px"></i>
                                        </div>
                                    </div>
                                    <div class="button-add-time" v-if="index == timeAutos.length - 1">
                                        <button class="btn btn-success btn-add-time mt-0" @click="timeAutos.push('')"><i class="icon ion-md-add"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="table table-borderless" v-show="inputTime">
                        <tr v-for="(valueDay, key) in sortDays" :key="key">
                            <td class="p-0 pt-3" width="30" style="vertical-align: top !important;">
                                <div class="day-detail fw-600 mt-2">{{ valueDay.day }}</div>
                            </td>
                            <td class="p-0 pt-3">
                                <div class="d-flex flex-wrap flex-time">
                                    <div class="col-time-auto mt-2"
                                        v-for="(item, index) in valueDay.time" :key="index">
                                        <div class="d-flex">
                                            <div class="col-time mr-2 position-relative">
                                                <ldc-time placeholder="HH:mm"
                                                    :showSeconds="false"
                                                    :jumpMinutes="5"
                                                    v-model="valueDay.time[index]"
                                                    titleMobile="Thời gian"/>
                                                <div class="btn-delete-time position-absolute" role="button"
                                                    v-if="valueDay.time.length > 1"
                                                    @click="removeTime(key, index)">
                                                    <i class="icon ion-md-close text-danger fs-16px"></i>
                                                </div>
                                            </div>
                                            <div class="button-add-time" v-if="index == valueDay.time.length - 1">
                                                <button class="btn btn-success btn-add-time mt-0" @click="sortDays[key].time.push('')"><i class="icon ion-md-add"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                    <p class="mb-0 fs-12px text-secondary mt-2">* Thời gian mặc định: 00:00</p>
                </div>
            </div>
        </div>
        <div class="mt-5 mt-mobile">
            <p class="text-center mb-0 text-danger mb-2 fs-14px" v-if="count > 1000">Quá 1000 lần up. Vui lòng điều chỉnh lại</p>
            <p class="text-center mb-0 text-danger mb-2 fs-14px"
                v-else-if="total > money.money">
                Quá số điểm trong tài khoản, Vui lòng nạp thêm {{money.unit}}
            </p>
            <div class="btn-confirm mb-3">
                <button class="btn btn-primary mx-auto py-1"
                    :disabled="count <= 0 || loading || count > 1000" @click="submit()">
                    Thực hiện
                </button>
            </div>
        </div>

    </div>
</template>
<script>
import { getMinutes, getDayInWeek } from '@/config/function';
export default {
    props: ['product', 'price'],
    data() {
        return {
            day: [
                {
                    value: 'T2',
                    label: 'Thứ 2'
                },
                {
                    value: 'T3',
                    label: 'Thứ 3'
                },
                {
                    value: 'T4',
                    label: 'Thứ 4'
                },
                {
                    value: 'T5',
                    label: 'Thứ 5'
                },
                {
                    value: 'T6',
                    label: 'Thứ 6'
                },
                {
                    value: 'T7',
                    label: 'Thứ 7'
                },
                {
                    value: 'CN',
                    label: 'Chủ Nhật'
                },
            ],
            inputTime: false,
            valueDays: [],
            sortDays: [],
            count: 1,
            total: 0,
            timeAutos: [''],
            loading: false,
            allDay: false,
        }
    },
    computed: {
        config(){
            return this.$store.state.config;
        },
        money(){
            return this.$store.state.money;
        },
    },
    created() {
        this.total = formatNumber(this.price)
    },
    mounted(){
        this.valueDays = ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'];
    },
    watch: {
        valueDays(val) {
            let sort = [...val];
            let oldSortDays = [...this.sortDays];
            this.sortDays = [];
            let check = null;
            if(val.length == 7){
                this.allDay = true;
            }else{
                this.allDay = false;
            }
            sort.sort().map(item => {
                check = this.checkOld(oldSortDays, item);
                if(check !== null){
                    this.sortDays.push(check)
                }else{
                    this.sortDays.push({
                        day: item,
                        time: [''],
                    });
                }
            });
        },
        product: {
            handler(val){
                this.calculateCount();
            },
            deep: true,
        },
        price(val){
            this.total = formatNumber(val);
        },
        total(val){
            this.$emit('update:price', stringToNumber(val));
            // this.calculateCount();
        },
    },
    methods: {
        changeAllDay(){
            if(this.allDay){
                this.valueDays = ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'];
            }else{
                this.valueDays = [];
            }
        },
        calculateTotal(){
            let check = stringToNumber(this.count);
            if(check > 0 && check <= 10000){
                this.count = formatNumber(check);
            }else{
                if(check <= 0){
                    this.count = '1';
                }else{
                    this.count = formatNumber(10000);
                }
            }
            this.total = formatNumber(this.product.length * stringToNumber(this.count) * (this.config.con_product_auto_up_price ? this.config.con_product_auto_up_price.money : this.$getEnv('VUE_APP_RV_UP_PRICE', true)));
        },
        calculateCount(){
            let check = stringToNumber(this.total);
            if(check >= 0 &&  check <= 10000 * (this.config.con_product_auto_up_price ? this.config.con_product_auto_up_price.money : this.$getEnv('VUE_APP_RV_UP_PRICE', true))){
                this.count = formatNumber(Math.floor(stringToNumber(this.total) / (this.product.length * (this.config.con_product_auto_up_price ? this.config.con_product_auto_up_price.money : this.$getEnv('VUE_APP_RV_UP_PRICE', true)))))
                this.total = formatNumber(check);
            }else{
                if(check < 0){
                    this.count = '1';
                    this.total = 1 * (this.config.con_product_auto_up_price ? this.config.con_product_auto_up_price.money : this.$getEnv('VUE_APP_RV_UP_PRICE', true));
                }else{
                    this.total = formatNumber(10000 * (this.config.con_product_auto_up_price ? this.config.con_product_auto_up_price.money : this.$getEnv('VUE_APP_RV_UP_PRICE', true)) * this.product.length);
                    this.count = formatNumber(10000)
                }
            }
        },
        reset(){
            this.valueDays = [];
            this.count = 1;
            this.timeAutos = [''];
            this.inputTime = false;
            this.calculateTotal();
            this.allDay = false;
        },
        checkOld(oldSortDays, day){
            let check = null;
            oldSortDays.map((item, index) => {
                if(item.day === day){
                    check = item;
                }
            });
            return check;
        },
        removeTime(key, index = null){
            if(this.inputTime){
                if(this.sortDays[key].time.length > 1){
                    this.sortDays[key].time.splice(index, 1);
                }
            } else {
                if(this.timeAutos.length > 1){
                    this.timeAutos.splice(key, 1);
                }
            }
        },
        async submit(){
            if(stringToNumber(this.total) > this.money.money){
                this.$message({
                    message: `Vượt quá số ${this.money.unit} có trong tài khoản, Vui lòng nạp ${this.money.unit}`,
                    type: 'warning',
                    center: true,
                });
                return;
            }else if(this.count > 10000){
                this.$message({
                    message: 'Vượt quá 10.000 lượt up, vui lòng điều chỉnh lại',
                    type: 'warning',
                    center: true,
                });
                return;
            }else if(this.sortDays.length == 0){
                this.$message({
                    message: 'Vui lòng chọn ngày up',
                    type: 'warning',
                    center: true,
                });
                return;
            }
            let schedule = {}, dataTime = [];
            if(this.inputTime){
                this.sortDays.map((item, index) => {
                    dataTime = [];
                    item.time.map(one => {
                        dataTime.push(getMinutes(one))
                    })
                    schedule[getDayInWeek(item.day)] = dataTime;
                })
            }else{
                this.timeAutos.map(item => {
                    dataTime.push(getMinutes(item))
                });
                this.sortDays.map((item, index) => {
                    schedule[getDayInWeek(item.day)] = dataTime;
                })
            }
            this.loading = true
            console.log(this.product)
            this.postData(schedule)
            this.reset();
            this.$eventBus.$emit('reset-auto-up', true);
            getMoney();
            this.loading = false;
        },
        async postData(schedule){
            console.log((schedule))
            let data = {
                id: this.$route.query.id,
                type: 1,
                quantity: stringToNumber(this.count),
                schedule: JSON.stringify(schedule)
            }
            await apiPost('/v2/profile/product/schedule_auto_up', data).then(res => {
                 if(res.success == 1){
                    this.$message({
                        message: `Đặt lịch up tự động thành công cho id: ${this.$route.query.id}`,
                        type: 'success',
                        center: true,
                    })
                    this.$eventBus.$emit('call-history-auto-up', this.$route.query.id);
                    location.reload();
                }
            }).catch(err => {
                if(err.status == 500){
                    this.$message({
                        message: `Lỗi hệ thống vui lòng thực hiện lại`,
                        type: 'error',
                        center: true,
                    })
                }
            });
        }
    }
}
</script>
<style lang="scss">
    .auto-up-rv-web {
        .up-for-date {
            .w-30 {
                width: 30%;
            }
            .w-70 {
                width: 70%;
                .input-number-up {
                    border: none;
                    border-bottom: 1px solid #000;
                    width: 50px;
                    border-radius: 0 !important;
                    &:focus {
                        outline: none;
                    }
                }
                .text-warning-up {
                    color: rgba(0, 0, 0, 0.5);
                }
                .input-timedate-up {
                    border: none;
                    border-bottom: 1px solid #000;
                    width: 50px;
                }
                .btn-add-time {
                    padding: 2px 15px;
                    font-size: 14px;
                    display: inline-block;
                    height: 30px;
                    margin-top: -3px;
                }
                .btn-recharge {
                    text-decoration: underline;
                }
                .ldc-time {
                    display: inline-block;
                    input {
                        height: 30px !important;
                        width: 115px !important;
                    }
                }
                .time-up-detail {
                    .custom-control-label {
                        padding-top: 2px;
                    }
                    .col-time-auto {
                        .col-stt {
                            width: 30px;
                            padding-top: 3px;
                        }
                        .col-time {
                            .btn-delete-time {
                                width: 20px;
                                height: 20px;
                            }
                        }
                    }
                    .flex-time {
                        width: calc(100% - 10px);
                    }
                    .btn-delete-time {
                        z-index: 1000;
                        top: 4px;
                        right: 0;
                    }
                }
                .input-price-up {
                    border: none;
                    border-bottom: 1px solid #000;
                    width: 75px;
                    border-radius: 0 !important;
                    color: #dc3545;
                    font-weight: 600;
                    &:focus {
                        outline: none;
                    }
                }
            }
        }
        .btn-confirm {
            display: flex;
            justify-content: center;
            align-items: center;
            button {
                padding-left: 40px;
                padding-right: 40px;
            }
        }
    }
    .auto-up-rv-mobile {
        .up-for-date {
            margin: 24px 0 0 0 !important;
            .w-30 {
                width: 40%;
                font-size: 14px;
            }
            .w-70 {
                width: 60%;
                font-size: 14px;
                .text-warning-up {
                    color: rgba(0, 0, 0, 0.5);
                }
                .input-timedate-up {
                    border: none;
                    border-bottom: 1px solid #000;
                    width: 50px;
                }
                .col-date {
                    width: 25%;
                    margin-top: 5px;
                }
                .max-up-mobile {
                    display: block;
                    margin: 5px 0 0 0 !important;
                }
            }
            .btn-recharge {
                text-decoration: underline;
            }
            .input-number-up {
                border: none;
                border-bottom: 1px solid #000;
                width: 35px;
                border-radius: 0 !important;
            }
            .input-price-up {
                border: none;
                border-bottom: 1px solid #000;
                width: 75px;
                font-weight: 600;
                color: #dc3545;
            }
            .col-time-auto {
                .btn-add-time {
                    width: 35px;
                    height: 35px;
                    font-size: 25px;
                    line-height: 35px;
                    padding: 0;
                }
                .btn-delete-time {
                    z-index: 999;
                    top: 6px;
                    right: 0;
                    width: 30px;
                    height: 30px;
                    padding-left: 10px;
                }
            }
            .select-up-detail {
                .ldc-select-show-option {
                    padding: 0 !important;
                    .option {
                        padding: 8px 0 !important;
                        border-radius: 4px !important;
                        font-size: 14px !important;
                        width: calc( 25% - 8px ) !important;
                        text-align: center !important;
                        &:nth-child(4n+4) {
                            margin-right: 0 !important;
                        }
                    }
                    .bg-primary {
                        box-shadow: 0 4px 6px rgba(50,50,93,.11),0 1px 3px rgba(0,0,0,.08) !important;
                    }
                }
            }
        }
        .mt-mobile {
            margin-top: 24px !important;
        }
        .btn-confirm {
            display: flex;
            justify-content: center;
            align-items: center;
            button {
                padding-left: 40px;
                padding-right: 40px;
            }
        }
        .custom-radio {
            font-size: 14px;
        }
    }
</style>
